import "vue/jsx";
import { createApp } from "vue";
// import "./../index.css";
import App from "./App";
import { router } from "./router";

export const app = createApp(App);
app.use(router);
